import React, { useEffect, useState } from 'react';
import { Table, Typography, Spin, Input, Button, Space, Avatar } from 'antd';

export default function UserLoginLogPage() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filtered, setFiltered] = useState([]);

  useEffect(() => {
    fetch('/api/user-login-logs')
      .then(res => res.json())
      .then(data => {
        // 若 user 欄位存在，直接帶出 user.name
        const arr = Array.isArray(data) ? data : [];
        setLogs(arr);
        setFiltered(arr);
        setLoading(false);
      });
  }, []);

  const handleSearch = () => {
    if (!search) {
      setFiltered(logs);
      return;
    }
    const s = search.trim().toLowerCase();
    setFiltered(
      logs.filter(
        log =>
          String(log.userId).includes(s) ||
          (log.user && log.user.name && log.user.name.toLowerCase().includes(s)) ||
          (log.ipAddress && log.ipAddress.toLowerCase().includes(s)) ||
          (log.status && log.status.toLowerCase().includes(s)) ||
          (log.errorMessage && log.errorMessage.toLowerCase().includes(s))
      )
    );
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 60, sorter: (a, b) => a.id - b.id },
    { title: '用戶ID', dataIndex: 'userId', key: 'userId', width: 80, sorter: (a, b) => (a.userId || 0) - (b.userId || 0) },
    {
      title: '用戶名稱',
      dataIndex: ['user', 'name'],
      key: 'userName',
      width: 180,
      render: (_, record) => record.user ? (
        <span>
          <Avatar size="small" src={record.user.pictureUrl} style={{ marginRight: 8 }} />
          {record.user.name}
        </span>
      ) : '',
      sorter: (a, b) => ((a.user?.name || '').localeCompare(b.user?.name || ''))
    },
    { title: 'IP', dataIndex: 'ipAddress', key: 'ipAddress', width: 120, sorter: (a, b) => (a.ipAddress || '').localeCompare(b.ipAddress || '') },
    { title: '登入時間', dataIndex: 'loginTime', key: 'loginTime', width: 180,
      render: t => {
        if (!t) return '';
        const dt = new Date(t);
        const taipei = dt.toLocaleString('zh-TW', {
          timeZone: 'Asia/Taipei',
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
        });
        // 格式如 '2025/06/18 15:04:05'，替換斜線
        return taipei.replace(/\//g, '-');
      },
      sorter: (a, b) => new Date(a.loginTime || 0) - new Date(b.loginTime || 0)
    },
    { title: '狀態', dataIndex: 'status', key: 'status', width: 80, sorter: (a, b) => (a.status || '').localeCompare(b.status || '') },
    { title: '錯誤訊息', dataIndex: 'errorMessage', key: 'errorMessage', sorter: (a, b) => (a.errorMessage || '').localeCompare(b.errorMessage || '') },
  ];

  return (
    <div>
      <Typography.Title level={3}>使用者登入記錄</Typography.Title>
      <Space style={{ marginBottom: 16 }}>
        <Input
          placeholder="搜尋 用戶ID/IP/狀態/錯誤訊息"
          value={search}
          onChange={e => setSearch(e.target.value)}
          onPressEnter={handleSearch}
          allowClear
          style={{ width: 240 }}
        />
        <Button type="primary" onClick={handleSearch}>查詢</Button>
      </Space>
      {loading ? <Spin /> : <Table rowKey="id" columns={columns} dataSource={filtered} pagination={{ pageSize: 20 }} />}
    </div>
  );
}
